import { Reducer } from 'redux';
import { IMobileNavMenuActions, MobileNavMenuActionType } from 'redux/actions/MobileNavMenuActions';

const initialState: boolean = false;
export const mobileNavMenuReducer: Reducer<boolean, IMobileNavMenuActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case MobileNavMenuActionType.TOGGLE_NAV_MENU:
                {
                    return !state;
                }
            case MobileNavMenuActionType.HIT_MENU:
                return false;
            default:
                return state;
        }
    };
